import { render, staticRenderFns } from "./LeftTransacaoOnline.vue?vue&type=template&id=20019996&scoped=true"
import script from "./LeftTransacaoOnline.vue?vue&type=script&lang=js"
export * from "./LeftTransacaoOnline.vue?vue&type=script&lang=js"
import style0 from "./LeftTransacaoOnline.vue?vue&type=style&index=0&id=20019996&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20019996",
  null
  
)

export default component.exports